// extracted by mini-css-extract-plugin
export var rateTable = "_56-0";